module.exports = __webpack_public_path__ + "static/media/download-shared-files-logo.b094252d.svg";